import React from 'react';
import { useNavigate } from 'react-router-dom';
import { width } from "../../components/CustomComponents/DynamicCard/DynamicCardStyles";
import DynamicCard from '../../components/CustomComponents/DynamicCard';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import HomeLayout from '../Layout/HomeLayout';
import HomeHeader from '../CustomComponents/HomeHeader';
import { appTheme } from '../../helpers/utils/Utils';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import CardHeading from '../CustomComponents/CardHeading';

const ManageMoney = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const cards = useSelector((state) => JSON.parse(state.userCards));

  useDocumentTitle(t('page_title_manage_money'));

  const otherOptionsColor = kudzuPlusTrue ? '#C2C6D0' : '#262B3A';

  const handleNavigation = (path) => {
    global.selectedAccountServiceCardKey = cards?.[0]?.CardKey;
    navigate(path, { state: { from: 'ManageMoney' } });
  };

  // Transfer Money Icon
  const TransferIcon = () => (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="48" height="48" rx="24" fill="#94C3E8" fill-opacity="0.2" />
          <path d="M27.3457 11.3625C27.1611 10.871 27.6639 10.4019 28.1413 10.6202L36.8127 14.5852C37.1038 14.7183 37.2355 15.0597 37.1087 15.3535L32.6921 25.5914L31.11 21.3808L28.4251 14.2379L28.426 14.2375L27.3457 11.3625ZM28.4051 14.1984L31.2337 21.7266L16.8631 27.1262C16.559 27.2403 16.2199 27.0858 16.1056 26.7817L13.6909 20.3552C13.5768 20.0512 13.7306 19.7124 14.0345 19.5981L28.4051 14.1984Z" fill="#2965FB" />
          <path d="M16.3231 27.2223L30.829 21.7719C31.1331 21.6576 31.473 21.8118 31.5873 22.116L33.9729 28.4648C34.0869 28.7689 33.9325 29.108 33.6284 29.2223L19.1225 34.6727L20.1152 37.3147C20.2992 37.8051 19.7989 38.2735 19.3217 38.0572L10.5995 34.1039C10.3068 33.9713 10.1744 33.6277 10.3025 33.333L14.766 23.0784L16.3231 27.2223Z" fill="#94C3E8" />
          <rect width="16.1276" height="2.4" transform="translate(15.9688 26.3066) rotate(-19.4375)" fill="white" />
      </svg>

    );
    const TransferIconPlus = () => (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="24" fill="#424D6C" />
            <path d="M27.3361 11.3835C27.1517 10.8922 27.6544 10.4231 28.1317 10.6412L36.8034 14.6072C37.0944 14.7402 37.2261 15.0816 37.0994 15.3754L32.6828 25.6133L31.1004 21.4018L31.0995 21.4021L28.4158 14.2598L28.4167 14.2594L27.3361 11.3835ZM28.3963 14.2191L31.225 21.7472L16.8534 27.1472C16.5495 27.2611 16.2107 27.1075 16.0963 26.8036L13.6816 20.3771C13.5674 20.0731 13.7209 19.7335 14.0248 19.6191L28.3963 14.2191Z" fill="white" />
            <path d="M16.3163 27.2478L30.8213 21.7977C31.1255 21.6834 31.4654 21.8376 31.5797 22.1418L33.9652 28.4907C34.0792 28.7947 33.9248 29.1339 33.6207 29.2481L19.1157 34.6982L20.1077 37.3383C20.2917 37.8288 19.7915 38.2972 19.3143 38.0809L10.592 34.1276C10.2993 33.9949 10.167 33.6513 10.2951 33.3566L14.7586 23.1021L16.3163 27.2478Z" fill="#94C3E8" />
            <rect width="16.1276" height="2.4" transform="translate(15.9688 26.3047) rotate(-19.4375)" fill="#2965FB" />
        </svg>
    );

  // Load Cash Icon
  const LoadCashIcon = () => (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="48" height="48" rx="24" fill="#94C3E8" fill-opacity="0.2" />
          <path d="M24.0001 11.7529C21.4015 11.7529 18.9094 12.7455 17.0719 14.5123C15.2344 16.2791 14.2021 18.6754 14.2021 21.174C14.2021 29.653 24.0001 36.2478 24.0001 36.2478C24.0001 36.2478 33.7981 29.653 33.7981 21.174C33.7981 18.6754 32.7658 16.2791 30.9283 14.5123C29.0908 12.7455 26.5987 11.7529 24.0001 11.7529ZM24.0001 24.9425C23.225 24.9425 22.4672 24.7215 21.8227 24.3074C21.1782 23.8933 20.6759 23.3048 20.3793 22.6162C20.0826 21.9276 20.005 21.1699 20.1562 20.4389C20.3075 19.7079 20.6807 19.0364 21.2288 18.5093C21.7769 17.9823 22.4753 17.6234 23.2355 17.478C23.9958 17.3326 24.7838 17.4072 25.4999 17.6925C26.216 17.9777 26.8281 18.4607 27.2588 19.0804C27.6894 19.7001 27.9193 20.4287 27.9193 21.174C27.9193 22.1735 27.5064 23.132 26.7714 23.8387C26.0364 24.5455 25.0395 24.9425 24.0001 24.9425Z" fill="#2965FB" />
          <path d="M24.0001 24.9425C23.225 24.9425 22.4672 24.7215 21.8227 24.3074C21.1782 23.8933 20.6759 23.3048 20.3793 22.6162C20.0826 21.9276 20.005 21.1699 20.1562 20.4389C20.3075 19.7079 20.6807 19.0364 21.2288 18.5093C21.7769 17.9823 22.4753 17.6234 23.2355 17.478C23.9958 17.3326 24.7838 17.4072 25.4999 17.6925C26.216 17.9777 26.8281 18.4607 27.2588 19.0804C27.6894 19.7001 27.9193 20.4287 27.9193 21.174C27.9193 22.1735 27.5064 23.132 26.7714 23.8387C26.0364 24.5455 25.0395 24.9425 24.0001 24.9425Z" fill="white" />
      </svg>
    );
    const LoadCashIconPlus = () => (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="24" fill="#424D6C" />
            <path d="M24.0011 11.7529C21.4025 11.7529 18.9104 12.7455 17.0729 14.5123C15.2354 16.2791 14.2031 18.6754 14.2031 21.174C14.2031 29.653 24.0011 36.2478 24.0011 36.2478C24.0011 36.2478 33.799 29.653 33.799 21.174C33.799 18.6754 32.7668 16.2791 30.9293 14.5123C29.0918 12.7455 26.5997 11.7529 24.0011 11.7529ZM24.0011 24.9425C23.2259 24.9425 22.4682 24.7215 21.8237 24.3074C21.1792 23.8933 20.6769 23.3048 20.3802 22.6162C20.0836 21.9276 20.006 21.1699 20.1572 20.4389C20.3084 19.7079 20.6817 19.0364 21.2298 18.5093C21.7779 17.9823 22.4762 17.6234 23.2365 17.478C23.9967 17.3326 24.7848 17.4072 25.5009 17.6925C26.217 17.9777 26.8291 18.4607 27.2598 19.0804C27.6904 19.7001 27.9203 20.4287 27.9203 21.174C27.9203 22.1735 27.5074 23.132 26.7724 23.8387C26.0374 24.5455 25.0405 24.9425 24.0011 24.9425Z" fill="white" />
            <path d="M24.0011 24.9425C23.2259 24.9425 22.4682 24.7215 21.8237 24.3074C21.1792 23.8933 20.6769 23.3048 20.3802 22.6162C20.0836 21.9276 20.006 21.1699 20.1572 20.4389C20.3084 19.7079 20.6817 19.0364 21.2298 18.5093C21.7779 17.9823 22.4762 17.6234 23.2365 17.478C23.9967 17.3326 24.7848 17.4072 25.5009 17.6925C26.217 17.9777 26.8291 18.4607 27.2598 19.0804C27.6904 19.7001 27.9203 20.4287 27.9203 21.174C27.9203 22.1735 27.5074 23.132 26.7724 23.8387C26.0374 24.5455 25.0405 24.9425 24.0011 24.9425Z" fill="#2965FB" />
        </svg>

    );
   

  // Load Check Icon
  const LoadCheckIcon = () => (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="48" height="48" rx="24" fill="#94C3E8" fill-opacity="0.2" />
          <rect x="10.8047" y="16.4238" width="26.4025" height="15.1176" fill="#2965FB" />
          <rect x="23.9863" y="25.8545" width="9.068" height="2.12924" rx="1.06462" fill="white" />
          <rect x="14.7422" y="21.3584" width="18.3114" height="2.12924" rx="1.06462" fill="white" />
          <path d="M32.7286 15.3594H38.2646V20.8954" stroke="#94C3E8" stroke-width="2.12924" />
          <path d="M15.2723 15.3594H9.73633V20.8954" stroke="#94C3E8" stroke-width="2.12924" />
          <path d="M32.7286 32.6396H38.2646V27.1036" stroke="#94C3E8" stroke-width="2.12924" />
          <path d="M15.2723 32.6396H9.73633V27.1036" stroke="#94C3E8" stroke-width="2.12924" />
      </svg>

    );
    const LoadCheckIconPlus = () => (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="24" fill="#424D6C" />
            <rect x="10.8047" y="16.4248" width="26.4025" height="15.1176" fill="white" />
            <rect x="23.9844" y="25.8564" width="9.068" height="2.12924" rx="1.06462" fill="#4076FF" />
            <rect x="14.7422" y="21.3613" width="18.3114" height="2.12924" rx="1.06462" fill="#4076FF" />
            <path d="M32.7257 15.3613H38.2617V20.8973" stroke="#94C3E8" stroke-width="2.12924" />
            <path d="M15.2704 15.3613H9.73438V20.8973" stroke="#94C3E8" stroke-width="2.12924" />
            <path d="M32.7257 32.6387H38.2617V27.1027" stroke="#94C3E8" stroke-width="2.12924" />
            <path d="M15.2704 32.6387H9.73438V27.1027" stroke="#94C3E8" stroke-width="2.12924" />
        </svg>

    );

  // Direct Deposit Icon  
  const DirectDepositIcon = () => (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="48" height="48" rx="24" fill="#94C3E8" fill-opacity="0.2" />
          <rect x="12.5859" y="12.4805" width="22.8286" height="23.04" rx="1.92669" fill="#2965FB" />
          <path d="M24.6181 31.1024C24.3996 31.28 24.0872 31.2825 23.8659 31.1083L17.2504 25.8994C16.8014 25.5458 17.0514 24.8242 17.6229 24.8242L20.6569 24.8242C20.9894 24.8242 21.259 24.5547 21.259 24.2221L21.259 18.1382C21.259 17.8057 21.5286 17.5361 21.8611 17.5361L26.4343 17.5361C26.7668 17.5361 27.0363 17.8057 27.0363 18.1382L27.0363 24.2221C27.0363 24.5547 27.3059 24.8242 27.6384 24.8242L30.6467 24.8242C31.2135 24.8242 31.4663 25.536 31.0265 25.8935L24.6181 31.1024Z" fill="white" />
      </svg>

    );
    const DirectDepositIconPlus = () => (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="24" fill="#424D6C" />
            <rect x="12.5859" y="12.4805" width="22.8286" height="23.04" rx="1.92669" fill="white" />
            <path d="M24.618 31.1072C24.3994 31.2849 24.0869 31.2873 23.8657 31.1131L17.25 25.9032C16.8011 25.5497 17.0511 24.8281 17.6225 24.8281L20.6567 24.8281C20.9892 24.8281 21.2588 24.5586 21.2588 24.226L21.2588 18.1412C21.2588 17.8086 21.5284 17.5391 21.8609 17.5391L26.4341 17.5391C26.7666 17.5391 27.0362 17.8086 27.0362 18.1412L27.0362 24.226C27.0362 24.5586 27.3057 24.8281 27.6382 24.8281L30.6467 24.8281C31.2135 24.8281 31.4663 25.5399 31.0265 25.8974L24.618 31.1072Z" fill="#4076FF" />
            <path d="M24.6141 31.1053C24.3955 31.2829 24.083 31.2854 23.8618 31.1111L17.2461 25.9013C16.7971 25.5477 17.0472 24.8262 17.6186 24.8262L20.6528 24.8262C20.9853 24.8262 21.2549 24.5566 21.2549 24.2241L21.2549 18.1392C21.2549 17.8067 21.5245 17.5371 21.857 17.5371L26.4302 17.5371C26.7627 17.5371 27.0322 17.8067 27.0322 18.1392L27.0322 24.2241C27.0322 24.5566 27.3018 24.8262 27.6343 24.8262L30.6428 24.8262C31.2096 24.8262 31.4624 25.5379 31.0226 25.8955L24.6141 31.1053Z" fill="#4076FF" />
            <path d="M24.6095 31.0976C24.391 31.2752 24.0785 31.2776 23.8573 31.1034L17.2426 25.8945C16.7936 25.5409 17.0436 24.8193 17.6151 24.8193L20.3295 24.8193L20.6489 24.819C20.9812 24.8186 21.2504 24.5492 21.2504 24.2169L21.2504 18.1314C21.2504 17.7989 21.5199 17.5293 21.8525 17.5293L26.4256 17.5293C26.7582 17.5293 27.0277 17.7989 27.0277 18.1314L27.0277 24.3911C27.0277 24.6271 27.219 24.8184 27.455 24.8184L27.8817 24.8184C27.882 24.8184 27.8822 24.8186 27.8822 24.8188C27.8822 24.8191 27.8824 24.8193 27.8827 24.8193L30.6389 24.8193C31.2057 24.8193 31.4585 25.5312 31.0186 25.8887L24.6095 31.0976Z" fill="#2965FB" />
        </svg>

    );

  const mainOptions = [
    {
      id: 'transfer-money',
      title: t('Transfer_Money'),
      icon: TransferIcon,
      iconPlus: TransferIconPlus,
      path: '/AccountServices/Spending/TransferMoney',
      bgColor: 'bg-[#F7F9FA]',
      bgColorPlus: 'bg-[#313A52]',
    },
    {
      id: 'load-cash',
      title: t('Load_Cash'),
      icon: LoadCashIcon,
      iconPlus: LoadCashIconPlus,
      path: '/AccountServices/Spending/AddFunds/AddCash',
      bgColor: 'bg-[#F7F9FA]',
      bgColorPlus: 'bg-[#313A52]',
    },
    {
      id: 'load-check',
      title: t('Load_Check'),
      icon: LoadCheckIcon,
      iconPlus: LoadCheckIconPlus,
      path: '/AccountServices/Spending/AddFunds',
      bgColor: 'bg-[#F7F9FA]',
      bgColorPlus: 'bg-[#313A52]',
    },
    {
      id: 'direct-deposit',
      title: t('Direct_Deposit'),
      icon: DirectDepositIcon,
      iconPlus: DirectDepositIconPlus,
      path: '/AccountServices/Spending/AddFunds/ManageDirectDeposit',
      bgColor: 'bg-[#F7F9FA]',
      bgColorPlus: 'bg-[#313A52]',
    },
  ];

  // Other options
  const otherOptionsArray = [
    { 
      id: 'manage-scheduled-transfers',
      name: t('Manage_Scheduled_Transfers'), 
      path: '/AccountServices/Spending/TransferMoney'
    },
    { 
      id: 'manage-external-accounts',
      name: t('Manage_External_Accounts'), 
      path: '/Settings/ManageExternalAccounts' 
    },
  ];
     

  return (
    <HomeLayout>
      <HomeHeader isHeaderCaption={true}
        heading={t('choose_manage_money')}
        subHeading=""
        showBackButton={true}
        backButtonRoute="/home"
          />
          <div className='flex flex-col md:w-[860px] sm:w-[464px]
w-[100%] animate__animated animate__fadeInRight '>
              <DynamicCard header={false}
                  CardRadius={true}
                  cardWidth={width.homeCard}
                  HeaderRadius={true}
                  isWhite={appThemeData.isWhiteBgForCard}
                  isDarkForKudzu={appThemeData.isDarkBgForCard}
                  backgroundColor={'--cardHeading-bg'}
                  HeaderContent={
                      <>
                          <CardHeading heading={t('Manage_Money')} />
                      </>
                  }
                  footer={true}
              >
                  <div style={{ minHeight: '660px' }}>

                      <div className={`${kudzuPlusTrue ? '' : 'border-[#A3CEBB] border-b-[3px]'} sm:mx-0 mx-4`}></div>

                    
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:my-[41px] sm:my-[20px] my-[20px]">
                              {mainOptions.map((option) => {
                                  const IconComponent = kudzuPlusTrue ? option.iconPlus : option.icon;
                                  const backgroundColor = kudzuPlusTrue ? option.bgColorPlus : option.bgColor;
                                  
                                  return (
                                      <div
                                          key={option.id}
                                          onClick={() => handleNavigation(option.path)}
                                          className={`${backgroundColor} rounded-xl p-4 cursor-pointer hover:shadow-lg transition-all duration-200 group`}
                                      >
                                          <div className="grid grid-cols-1">
                                              <div className="w-12 h-12 flex items-center justify-center">
                                                  <IconComponent />
                                              </div>

                                          </div>
                                          <div className="flex items-center justify-between mt-5 gap-4">
                                              <span className="font-hanken-grotesk font-[600] text-[16px] md:text-[16px] leading-[24px] text-[var(--text-clr-transactions)]">
                                                  {option.title}
                                              </span>
                                              <img style={{ width: '12px' }} src={appThemeData.CaretRight} alt="arrow" />

                                          </div>
                                      </div>
                                  );
                              })}
                          </div>
                      <div className="grid grid-cols-1  pt-10 border-t-[2px] border-[var(--transactions-manage-money-border)]">
                          <h3 className="font-hanken-grotesk font-[600] text-[12px] md:text-[13px] uppercase tracking-[2px] mb-7" style={{ color: otherOptionsColor }}>
                                  {t('Other_Options')}
                              </h3>

                              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                  {otherOptionsArray.map((option) => (
                                      <Link
                                          key={option.id}
                                          to={option.path}
                                          state={{ from: 'ManageMoney' }}
                                          onClick={() => {
                                              global.selectedAccountServiceCardKey = cards?.[0]?.CardKey;
                                          }}
                                          className="flex items-center justify-between pb-6 border-b-[2px] border-[var(--transactions-manage-money-border)] no-underline group"
                                      >
                                          <span className="font-hanken-grotesk font-[700] text-[14px] md:text-[16px] leading-[16px] text-[var(--text-clr-transactions)]">
                                              {option.name}
                                          </span>
                                          <img src={appThemeData.CaretRightBlack} alt="arrow" style={{ height: '12px' }} />

                                      </Link>
                                  ))}
                              </div>
                          </div>

                     
                  </div>
              </DynamicCard>
          </div>
        
    </HomeLayout>
  );
};

export default ManageMoney;
